var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"chart-avacne"}},[_c('fusioncharts',{attrs:{"type":_vm.type,"width":_vm.width,"height":_vm.height,"dataformat":_vm.dataFormat,"dataSource":_vm.dataSource}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }